import React, { useEffect, useState, useCallback } from "react";
import Input from "../../../../components/Common/Input/Input";
import DeleteIcon from "../../../../components/Common/SvgIcons/SocialIcons/DeleteIcon";
import {
  getAllAssignedSupportQueriesActionHandler,
  deleteQueryActionHandler,
  putQueryActionHandler,
  putUnreadCountActionHandler,
  putIsReadActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/myQueriesActionHandler";
import { useOutletContext, useNavigate } from "react-router";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScrollComponent from "../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import profileImg from "../../../../assets/images/Common/profileImg.svg";
import {
  putQueryAction,
  getAllAssignedSupportDataAction,
} from "../../../../store/actions/actionCreators/adminActionCreator/myQueryActionCreator";
import classes from "./Support.module.scss";
import Button from "../../../../components/Common/Button/Button";
import { FormattedMessage } from "react-intl";
import Loader from "../../../../components/Common/Loader/Loader";

const Support = () => {
  const pageSize = 50;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const commentReplies = useSelector((state) => state.myQueryReducer);
  const { queryDataSupport } = commentReplies;

  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile } = commonState;

  const [assignedData, setAssignedData] = useState([]);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [totalRows, settotalRows] = useState(0);
  const [epoch, setEpoch] = useState(0);
  const [queryreplies, setQueryReplies] = useState([]);
  const [queryListActive, setQueryListActive] = useState(null);
  // const [idstore, setIdStore] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [commentPost, setCommentPost] = useState("");
  const [postUnreadCount, setpostUnreadCount] = useState();
  // const [firstTimeActive, setfirstTimeActive] = useState(false);
  const [lastQueryDataSupoort, setLastQueryDataSupport] = useState();
  const [active, setActive] = useState(false);
  const [loader, setLoader] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if (queryDataSupport?.length > 0) {
      setLoader(false);
      setQueryReplies(queryDataSupport?.[0]);
      setQueryListActive(queryDataSupport?.[0]?.id);
    }
  }, [queryDataSupport?.length]); //queryDataSupport, setLoader


  useEffect(() => {
    if (lastQueryDataSupoort === null) {
      setHasMoreData(false);
    }
    if (epoch >= 0) {
      dispatch(
        getAllAssignedSupportQueriesActionHandler(
          "GENERAL",
          epoch,
          epoch > 0 ? 10 : pageSize,
          setLastQueryDataSupport,
          setLoader
        )
      );
    }
  }, [dispatch, epoch, lastQueryDataSupoort]);

  const fetchMoreData = () => {
    setEpoch(
      queryDataSupport[queryDataSupport.length - 1].EpochValue
        ? queryDataSupport[queryDataSupport.length - 1].EpochValue
        : 0
    );
  };

  const convertTime = (isoTime) => {
    var hours = parseInt(isoTime.substring(0, 2), 10),
      minutes = isoTime.substring(3, 5),
      ampm = "AM";

    if (hours == 12) {
      ampm = "pm";
    } else if (hours == 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
      ampm = "PM";
    }

    return hours + ":" + minutes + " " + ampm;
  };
  const convertTimeAmPm = (isoTime) => {
    var hours = parseInt(isoTime.substring(0, 2), 10),
      ampm = "AM";

    if (hours == 12) {
      ampm = "pm";
    } else if (hours == 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
      ampm = "PM";
    }

    return ampm;
  };
  const queryListClick = (data) => {
    setQueryReplies(data);
    setQueryListActive(data?.id);
    if (data.IsReadByAdmin === false) {
      dispatch(putUnreadCountActionHandler(setpostUnreadCount));
      dispatch(putIsReadActionHandler(data?.id)).then((response) => {
        if (response.data) {
          const updatedData = queryDataSupport?.map((query) => {
            if (query?.id === data?.id) {
              return { ...query, IsReadByAdmin: response?.data };
            } else {
              return { ...query };
            }
          });
          dispatch(getAllAssignedSupportDataAction(updatedData));
        }
      });
    }
  };

  const selectAllCheckbox = () => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(queryDataSupport?.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };
  const selectCheckbox = (data, e) => {
    // idstore.push(data.id);
    // const { id, checked } = e.target;
    // setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   setIsCheck(isCheck.filter((item) => item !== id));
    // }
    const { id, checked } = e.target;
    let updatedIsCheck = [...isCheck];
    if (checked) {
      updatedIsCheck = [...isCheck, id];
    } else {
      updatedIsCheck = isCheck.filter((item) => item !== id);
    }
    setIsCheck(updatedIsCheck);
    setIsCheckAll(updatedIsCheck.length === queryDataSupport.length);
  };

  const deleteSelectedQuery = () => {
    dispatch(deleteQueryActionHandler(isCheck)).then((response) => {
      if (response.data) {
        dispatch(
          getAllAssignedSupportQueriesActionHandler(
            "GENERAL",
            0,
            // epoch > 0 ? 10 : pageSize,
            pageSize,
            setLastQueryDataSupport,
            setLoader,
            true
          )
        ).then((newQueryData) => {
          if (newQueryData?.data?.length > 0) {
            setQueryReplies(newQueryData?.data?.[0]);
            setQueryListActive(newQueryData?.data?.[0].id); // Set the first row as active
          } else {
            setQueryReplies([])
            setQueryListActive(null);
          }
        });
        dispatch(setErrorHandler(errorTypes.SUCCESS, "Query has been deleted"));
        setIsCheck([]);
      }
    });
  };
  const handleViewAttachemnt = (imgUrl) => {
    window.open(imgUrl, "_blank", "width=422, height=586").moveTo(800, 350);
  };
  const onSubmit = (data) => {
    setCommentPost(data.commentInput);
  };
  const handleComment = (e) => {
    setCommentPost(e.target.value);
  };
  const handleCommentBtn = () => {
    if (commentPost.trim()) {
      setBtnLoader(true);
      let data = {
        Category: {
          CategoryId: 2,
          CategoryName: "GENERAL",
          CategoryType: "GENERAL",
          DefaultAssignee: "",
        },
        CreatedBy: "",
        IsReadByAdmin: true,
        RelatedId: "",
        Replies: [
          {
            CreatedTime: `${queryreplies?.CreatedTime?.match(/\d\d:\d\d/)}`,
            Text: commentPost,
          },
        ],
        Text: "",
        id: queryreplies?.id,
      };
      dispatch(putQueryActionHandler(data)).then((response) => {
        if (response) {
          const updatedData = queryDataSupport?.map((query) => {
            if (query?.id === response?.data?.id) {
              return { ...query, Replies: response?.data?.Replies };
            } else {
              return { ...query };
            }
          });
          setQueryReplies(response?.data);
          dispatch(putQueryAction(updatedData));
          setCommentPost("");
          setBtnLoader(false);
        }
      });
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && commentPost.trim()) {
      setBtnLoader(true);
      let data = {
        Category: {
          CategoryId: 2,
          CategoryName: "GENERAL",
          CategoryType: "GENERAL",
          DefaultAssignee: "",
        },
        CreatedBy: "",
        IsReadByAdmin: true,
        RelatedId: "",
        Replies: [
          {
            CreatedTime: `${queryreplies?.CreatedTime?.match(/\d\d:\d\d/)}`,
            Text: commentPost,
          },
        ],
        Text: "",
        id: queryreplies?.id,
      };
      dispatch(putQueryActionHandler(data)).then((response) => {
        if (response) {
          const updatedData = queryDataSupport?.map((query) => {
            if (query?.id === response?.data?.id) {
              return { ...query, Replies: response?.data?.Replies };
            } else {
              return { ...query };
            }
          });
          setQueryReplies(response?.data);
          dispatch(putQueryAction(updatedData));
          setCommentPost("");
          setBtnLoader(false);
        }
      });
    }
  };
  return (
    // loader ? (
    //   <div className={classes.loader}>
    //     <Loader page />
    //   </div>
    // ) : (
    <div className={classes.supportMainBox}>
      {queryDataSupport?.length > 0 ? (
        <>
          <div className={classes.leftPanel}>
            <div className={classes.topHeader}>
              <h2>Support Queries</h2>
              <div className={classes.checkboxSelectAll}>
                <FormProvider {...methods}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Input
                      label={<FormattedMessage id="SELECT_ALL" />}
                      type="checkbox"
                      name="selectAll"
                      width="2"
                      height="2"
                      labelColor="light"
                      direction="row-reverse"
                      checked={isCheckAll}
                      onClick={selectAllCheckbox}
                    />
                  </form>
                </FormProvider>
              </div>
              {isCheck?.length > 0 && (
                <span
                  className={classes.topHeader_DeleteIcon}
                  onClick={deleteSelectedQuery}
                >
                  <DeleteIcon fill={"grey"} />
                  <FormattedMessage id="DELETE_TXT" />
                </span>
              )}
            </div>
            <div className={classes.supportQueriesContainer}>
              <InfiniteScrollComponent
                dataLength={queryDataSupport?.length}
                fetchMoreData={fetchMoreData}
                hasMoreData={hasMoreData}
                height={"58vh"}
              >
                {queryDataSupport?.map((query) => {
                  return (
                    <div
                      key={query?.id}
                      className={`${classes.queryList} ${
                        queryListActive === query?.id ? classes.itemActive : ""
                      }`}
                      onClick={() => queryListClick(query)}
                    >
                      <div className={classes.queryList__inner}>
                        <div className={classes.innerCheckboxCreatedName}>
                          <FormProvider {...methods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                              <Input
                                label={""}
                                type="checkbox"
                                name={`selectOneByOne${query?.id}`}
                                width="1.5"
                                id={query?.id}
                                height="1.5"
                                labelColor="light"
                                direction="row-reverse"
                                onClick={(e) => selectCheckbox(query, e)}
                                checked={isCheck.includes(query?.id)}
                              />
                            </form>
                          </FormProvider>
                          <div>
                            {query?.CreatedName}
                            <div
                              className={classes.queryTxt}
                              style={{
                                color: query?.IsReadByAdmin
                                  ? "#b6b6b6"
                                  : "#000",
                                fontWeight: query?.IsReadByAdmin
                                  ? "initial"
                                  : "700",
                              }}
                            >
                              {query?.Text}
                            </div>
                          </div>
                        </div>
                        <div className={classes.queryList__dateTime}>
                          <span>
                            {query?.ModifiedTime?.match(/([^T]+)/)[0]
                              .split("-")
                              .reverse()
                              .join("/")}
                          </span>
                          <span>
                            {convertTime(
                              `${query?.ModifiedTime?.match(/\d\d:\d\d/)}`
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </InfiniteScrollComponent>
            </div>
          </div>
          <div className={classes.rightPanel}>
            <div className={classes.rightPanel__inner}>
              <h4>Conversation Window :</h4>
              <div className={classes.innerTopHeader}>
                <div className={classes.createdName}>
                  {/* {queryreplies?.CreatedName} */}
                  {queryreplies?.Text}
                  {queryreplies?.QueryAttachmentUrl !== null && (
                    <div
                      className={classes.viewAttachement}
                      onClick={() =>
                        handleViewAttachemnt(queryreplies?.QueryAttachmentUrl)
                      }
                    >
                      <a href="#">
                        <FormattedMessage id="VIEWIMAGE_TEXT" />
                      </a>
                    </div>
                  )}
                </div>
                {/* <div className={classes.viewDetails}>View Details</div> */}
              </div>

              <div className={classes.chatWindow}>
                <div className={classes.innerMessage}>
                  {queryreplies?.Replies?.map((replies) => {
                    return (
                      <>
                        <div
                          className={`${classes.userChatMain} ${
                            replies?.CreatedBy === myProfile?.LoginId
                              ? ""
                              : classes.withAvtar
                          }`}
                        >
                          {replies.CreatedBy !== myProfile?.LoginId && (
                            <div className={classes.description_meta_info}>
                              <div className={classes.avtar}>
                                <img
                                  src={
                                    replies?.CommentedByPhotoUrl
                                      ? replies?.CommentedByPhotoUrl
                                      : profileImg
                                  }
                                  className={classes.avtar_image}
                                  alt="PROFILE_IMAGE"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = profileImg;
                                  }}
                                />
                              </div>
                              <div className={classes.avtar_name}>
                                {/* {replies?.CreatedBy} */}
                                {queryreplies?.CreatedName}
                              </div>
                            </div>
                          )}
                          <div
                            key={replies.CreatedTime}
                            className={classes.message}
                          >
                            {replies?.Text}
                            <div className={classes.createdName}>
                              <div className={classes.nameTime}>
                                <span className={classes.createName}>
                                  {replies?.CreatedName}
                                </span>
                                <span className={classes.createDateTime}>
                                  <span>
                                    {new Date(replies.CreatedTime)
                                      .toISOString()
                                      .slice(0, 10)
                                      .split("-")
                                      .reverse()
                                      .join("/")}
                                  </span>
                                  <span>
                                    {new Date(replies.CreatedTime)
                                      .toISOString()
                                      .substring(11, 19)}
                                  </span>
                                  <span>
                                    {convertTimeAmPm(
                                      `${replies?.CreatedTime?.match(
                                        /\d\d:\d\d/
                                      )}`
                                    )}
                                  </span>
                                </span>
                              </div>

                              {replies.ReplyAttachmentUrl !== null && (
                                <div
                                  className={classes.viewAttachement}
                                  onClick={() =>
                                    handleViewAttachemnt(
                                      replies?.ReplyAttachmentUrl
                                    )
                                  }
                                >
                                  <a href="#">View Image</a>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                  {queryreplies?.Replies === null && (
                    <div className={classes.chatNoMessage}>No Record Found</div>
                  )}
                </div>
              </div>

              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className={classes.chatInputEditor}>
                    <div className={classes.chatEditorField}>
                      <div className={classes.inputBox}>
                        <Input
                          label={""}
                          name="commentInput"
                          placeholder="Type your comment here"
                          width="100%"
                          height="0"
                          gap="0"
                          onChange={handleComment}
                          value={commentPost}
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                      <div className={classes.chatBtn}>
                        <Button
                          label={"Submit"}
                          type="submit"
                          borderRadius="2.4"
                          width="15"
                          dark
                          onClick={handleCommentBtn}
                          disabled={!commentPost.trim()}
                          loading={btnLoader}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={classes.noQueryFound}>No Queries found</div>
        </>
      )}
    </div>
  );
};

export default Support;
